import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import { decorationMobx, storeMobx } from '@mobxStore'
import { restaurantConfig } from 'restaurant'
import './index.scss'

interface IProps {
}

/** 餐品等待时间，等待单数 */
const WaitingProduct: React.FC<IProps> = () => {
  const { info: store } = storeMobx
  const { mealDecorates } = decorationMobx
  const { mealsWaitingTime = {} } = store
  const [showWaiting, setShowWaiting] = useState(true)
  // 显示等待时间
  const isShow = showWaiting &&
    (typeof store?.mealsWaitingTime?.waitingTime === 'number' && typeof store?.mealsWaitingTime?.leastTime === 'number' && store?.mealsWaitingTime?.waitingTime > store?.mealsWaitingTime?.leastTime) && (store?.mealsWaitingTime?.scene && !!store?.mealsWaitingTime?.scene[restaurantConfig.codeType === 'brand' ? 'pickup' : 'dinein'])
  return (
    isShow ? (
      <div className='menu-waiting-position-wrapper'>
        <p>
          <span>
            {!mealsWaitingTime?.content || mealsWaitingTime?.content?.order === 1 ? i18n.t('menu.mealsWaitingOrderNum', { cnt: mealsWaitingTime?.orderUnMealedNum }) : ''}
          </span>
          <span>
            {!mealsWaitingTime?.content || mealsWaitingTime?.content?.order === 1 && mealsWaitingTime?.content?.time === 1 ? '/' : ''}
          </span>
          <span>
            {!mealsWaitingTime?.content || mealsWaitingTime?.content?.time === 1 ? i18n.t('menu.mealsWaitingTime1', { minute: mealsWaitingTime?.waitingTime }) : ''}
          </span>
        </p>
        <i className='iconfont icon-close' onClick={() => { setShowWaiting(false) }}></i>
      </div>
    ) : null
  )
}

export default observer(WaitingProduct)
